export default "<div class=\"notfound\">\n  <h4>The requested page couldn't be found</h4>\n  <a [routerLink]=\"'/'\">Go to Home</a>\n</div>\n";